import spaisiTunec from './../../../image/sishi/spaisiTunec.webp'
import spaisiMidii from './../../../image/sishi/spaisiMidii.webp'
import tunec from './../../../image/sishi/tunec.webp'
import spaisiGrebeshok from './../../../image/sishi/spaisiGrebeshok.webp'
import spaisiIzumiTai from './../../../image/sishi/spaisiIzumiTai.webp'
import spaisiUgor from './../../../image/sishi/spaisiUgor.webp'
import spaisiLosos from './../../../image/sishi/spaisiLosos.webp'
import spaiseKrab from './../../../image/sishi/spaisiKrab.webp'


export const imagesSushi = {
    spaisiTunec:spaisiTunec,
    spaisiMidii:spaisiMidii,
    tunec:tunec,
    spaisiGrebeshok:spaisiGrebeshok,
    spaisiIzumiTai:spaisiIzumiTai,
    spaisiUgor:spaisiUgor,
    spaisiLosos:spaisiLosos,
    spaiseKrab:spaiseKrab


}